// extracted by mini-css-extract-plugin
export var option = "_81-0";
export var optionCard = "_81-f";
export var optionContent = "_81-g";
export var optionIcon = "_81-i";
export var optionIconBox = "_81-h";
export var optionLabel = "_81-j";
export var optionPill = "_81-m";
export var optionPillBadge = "_81-p";
export var optionPillIcon = "_81-n";
export var optionPillLabel = "_81-o";
export var optionRadio = "_81-k";
export var optionRadioInner = "_81-l";
export var optionReveal = "_81-2";
export var optionRevealDelay0 = "_81-3";
export var optionRevealDelay1 = "_81-4";
export var optionRevealDelay10 = "_81-d";
export var optionRevealDelay11 = "_81-e";
export var optionRevealDelay2 = "_81-5";
export var optionRevealDelay3 = "_81-6";
export var optionRevealDelay4 = "_81-7";
export var optionRevealDelay5 = "_81-8";
export var optionRevealDelay6 = "_81-9";
export var optionRevealDelay7 = "_81-a";
export var optionRevealDelay8 = "_81-b";
export var optionRevealDelay9 = "_81-c";
export var optionSelected = "_81-1";